<template>
  <div class="app-container">
    <div v-if="state!='production'"
         style="background: red;color:white;font-size:12px;position:absolute;z-index: 100000;top:0;left: 0;padding: 1px 8px">
      ฐานข้อมูลทดสอบ
    </div>

    <LineDialog></LineDialog>
    <AddressDialog></AddressDialog>
    <ProductDialog v-if="$store.state.dialog.product"></ProductDialog>
    <CustomerOldDialog v-if="$store.state.dialog.customer"></CustomerOldDialog>
    <CustomerDialog></CustomerDialog>
    <OrderOldDialog v-if="$store.state.dialog.order"></OrderOldDialog>
    <ItemDialog v-if="$store.state.dialog.item"></ItemDialog>
    <ItemDialogPoint v-if="$store.state.dialog.item_point"></ItemDialogPoint>
    <ShippingDialog></ShippingDialog>
    <OrderDialog></OrderDialog>
    <RouteDialog></RouteDialog>
    <RouteEditorDialog></RouteEditorDialog>
    <SlipDialog></SlipDialog>
    <OrderPicker></OrderPicker>
    <SalesDialog></SalesDialog>
    <PromotionDialog></PromotionDialog>
    <LocationMapPicker v-if="locationMapPickerOpen"
                       :option="onLocationMapPickerOption">
    </LocationMapPicker>

    <QrDialog></QrDialog>
    <DatePicker></DatePicker>
    <DateTimePicker></DateTimePicker>
    <TimeTablePicker></TimeTablePicker>
    <ImageGallery></ImageGallery>

    <CalculatorDialog></CalculatorDialog>
    <ProductChooserDialog></ProductChooserDialog>
    <OrderTypeChooserDialog></OrderTypeChooserDialog>

    <main id="appBody" class="app-body">
      <router-view/>


      <v-app-bar class="header-top" fixed height="50" top>
        <template v-slot:default>
          <v-tabs
              center-active
              centered
              class="no-slider"
              height="50"
              slider-color="slider"
              slider-size="5"
          >
            <v-tab :to="'/profile'">
              <v-avatar color="teal" size="40" style="margin-top: -5px">
                <img
                    v-if="$store.state.$user.picture"
                    :src="$store.state.$user.picture"
                />
                <v-icon v-else>mdi-account-circle</v-icon>
              </v-avatar>
            </v-tab>


            <TabForDialog v-for="(tab, index) in tabs" :tab="tab"></TabForDialog>
          </v-tabs>
        </template>
      </v-app-bar>
    </main>
    <v-snackbar
        v-model="snackbar"
        :bottom="true"
        :color="snackbar_color"
        :right="true"
        :timeout="2000"
        :vertical="true"
    >
      <h5>{{ snackbar_title }}</h5>
      <br>
      {{ snackbar_text }}
      <v-btn
          text
          @click="snackbar = false"
      >
        ปิด
      </v-btn>
    </v-snackbar>
  </div>
</template>
<style lang="scss">
.app-body {
  //color: white;
  margin-top: 60px;
  max-height: calc(100vh - 60px);
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  background-color: transparent !important;
}

.tr-clickable {
  tr {
    cursor: pointer;
  }
}

.clickable {
  cursor: pointer;
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  //white-space: nowrap;
  display: inline-block;
  width: 100%;
}


.header-top {
  z-index: 1 !important;
}

.no-slider {
  .v-slide-group__wrapper {
    /*background-color: #FFFFFF;*/
  }

  .v-slide-group__prev {
    display: none !important;
  }

  .v-tabs-slider-wrapper {
    top: 0 !important;

    .slider {
      /*background: linear-gradient(90deg, #6BD1ED 0%, #0054A4 100%);*/
    }
  }

  .v-tab {
    text-transform: none !important;
    padding-top: 5px;

    & .tab-content {
      display: grid;
      z-index: 9;
    }

    & .tab-img {
      margin: 0 auto;
    }

    &.v-tab--active {
      /*background-color: #273142;*/
    }
  }
}
</style>

<script>
import Api from '../providers/Api'
import LineDialog from '../dialogs/LineDialog'
import CustomerDialog from '../dialogs/CustomerDialog'
import CustomerOldDialog from '../dialogs/CustomerOldDialog'
import OrderOldDialog from '../dialogs/OrderOldDialog'
import OrderDialog from '../dialogs/OrderDialog'
import ShippingDialog from '../dialogs/ShippingDialog'
import RouteDialog from '../dialogs/RouteDialog'
import RouteEditorDialog from '../dialogs/RouteEditorDialog'
import ProductDialog from '../dialogs/ProductDialog'
import ItemDialog from '../dialogs/ItemDialog'
import ItemDialogPoint from '../dialogs/ItemDialogPoint'

import Helper from '../services/Helper'
import TabForDialog from '../components/TabForDialog'
import {gVariable} from '@/services/globalData'
import CalculatorDialog from '../dialogs/CalculatorDialog'
import SalesDialog from '../dialogs/SalesDialog'
import SlipDialog from '../dialogs/SlipDialog'
import ProductChooserDialog from '../dialogs/ProductChooserDialog'
import PromotionDialog from '@/dialogs/PromotionDialog'
import DatePicker from '@/dialogs/DatePicker'
import DateTimePicker from '@/dialogs/DateTimePicker'
import TimeTablePicker from '@/dialogs/TimeTablePicker'
import LocationMapPicker from '@/dialogs/LocationMapPicker'
import AddressDialog from '@/dialogs/AddressDialog'
import OrderPicker from '@/dialogs/OrderPicker'
import ImageGallery from '@/dialogs/ImageGallery.vue'
import QrDialog from '@/dialogs/QrDialog.vue'
import OrderTypeChooserDialog from '@/dialogs/OrderTypeChooserDialog.vue'


export default {
  components: {
    QrDialog,
    ImageGallery,
    AddressDialog,
    LocationMapPicker,
    DatePicker, DateTimePicker, TimeTablePicker,
    PromotionDialog,
    SlipDialog,
    SalesDialog,
    CalculatorDialog, TabForDialog, ProductDialog, OrderOldDialog, OrderDialog,
    ShippingDialog, CustomerDialog, CustomerOldDialog, LineDialog, ItemDialog, ItemDialogPoint, ProductChooserDialog,
    RouteDialog, RouteEditorDialog, OrderPicker, OrderTypeChooserDialog
  },
  data() {
    return {
      state: 'test',

      dialog: false,
      snackbar: false,
      snackbar_title: '',
      snackbar_color: 'error',
      snackbar_text: '',

      locationMapPickerOpen: false,
      onLocationMapPickerOption: {}
    }
  },
  computed: {
    tabs: function() {
      return gVariable.tabs_array.filter(tab => tab.permissions.length === 0 || tab.permissions.includes(this.$store.state.$user.role))
    }
  },

  mounted() {

  },
  created() {
    if (!Helper.checkLogin()) {
      this.$store.state.intended = this.$route.fullPath
      this.$router.push('/login')
    } else {
      this.getMe()
      this.getOtherUser()
      this.getConfig()

      if (this.$store.state.need_register_line) {
        this.dialog = true
      }
    }
    this.state = process.env.VUE_APP_STATE
    this.$root.$on('onSuccess', this.onSuccess)
    this.$root.$on('onWarning', this.onWarning)
    this.$root.$on('onError', this.onError)

    this.$root.$on('openLocationPicker', this.onOpenLocationPicker)
    this.$root.$on('closeLocationPicker', () => {
      this.locationMapPickerOpen = false
    })
    this.$root.$on('applyLocationPicker', (result) => {
      this.onLocationMapPickerApplyFunction(result)
      this.locationMapPickerOpen = false
    })
  },

  methods: {

    onOpenLocationPicker({option, onApply}) {
      if (this.locationMapPickerOpen) return
      console.log('Emitted onOpenLocationPicker', {option})
      this.onLocationMapPickerOption = option

      this.locationMapPickerOpen = true

      this.onLocationMapPickerApplyFunction = onApply
    },
    // onLocationMapPickerApply: (result) => {
    //   console.log('onLocationMapPickerApply', result)
    //   // this.onLocationMapPickerApplyFunction(result)
    //   this.locationMapPickerOpen = false
    // },
    // onLocationMapPickerClose: () => {
    //   console.log('onLocationMapPickerClose')
    //   this.$root.$emit('closeLocationPicker')
    // },
    onSuccess({title, message}) {
      this.snackbar = true
      this.snackbar_title = title ? title : 'Success'
      this.snackbar_color = 'success'
      this.snackbar_text = message

    },
    onWarning({title, message}) {
      this.snackbar = true
      this.snackbar_title = title ? title : 'Warning'
      this.snackbar_color = 'warning'
      this.snackbar_text = message
    },
    onError({title, message, error}) {
      this.snackbar = true
      this.snackbar_title = title ? title : 'Error'
      this.snackbar_color = 'error'
      if(!message && error){
        if(error.response?.data?.message){
          message = error.response.data.message
        }else if(error.message) {
          message = error.message
        }else{
          message = error.toString()
        }
      }

      this.snackbar_text = message
    },
    getMe() {
      // console.log('serial',this.$store.state.$user.serial)
      Helper.get('/api/me')
          .then(({data}) => {

            this.$store.commit('current_user', data.data)

            this.$vuetify.theme.dark = data.data.theme

            // tabs[0].badge = this.$store.state.$user.unread_notifications>0
            // gVariable.tabs.overview.name =  'xxx'+data.data.unread_notifications;
            // gVariable.tabs.overview.badge = this.$store.state.current_user.unread_notifications > 0
            // gVariable.tabs.overview.badge_number = data.data.unread_notifications

            // setTimeout(() => {this.getMe()}, 20000)
          })
          .catch(() => {
            // setTimeout(() => {this.getMe()}, 20000)
          })
    },
    async getOtherUser() {
      const users = await Helper.get(Helper.setting.user.getListAPI)
          .then(({data}) => {
            this.$store.commit('users_response', data)
            return data
          })
    },

    async getConfig() {
      const config = await Helper.get(Helper.setting.config.getListAPI)
          .then(({data}) => {
            this.$store.commit('config', data)
            return data
          })
    },

    logout() {
      this.$store.state.intended = null
      this.post('/api/logout')

      this.logOut()
    }

    // hasPermissions (permissions) {
    //   return permissions.length === 0 || _.intersection(permissions, this.$store.state.$user.permissions).length !== 0
    // },
    //
    // setPermission (permission) {
    //   this.page_permissions = permission
    // },
  },

  mixins: [
    Api
  ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
